import React from 'react'
import { createIconComponent } from '../Icon'

const OutlinedLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"/></svg>
)

const OutlinedSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="m480-190.157-243.999-121.23v-216.922L89.541-600 480-792.921 870.458-600v279.69H818.46v-254.46l-94.461 46.461v216.922L480-190.157ZM480-465l270.615-135L480-735 209.385-600 480-465Zm0 216.537 192-96v-157.846L480-407.15l-192-95.159v157.846l192 96ZM480-465Zm0 63.306Zm0 0Z"/></svg>
)

const FilledLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M840-280v-276L480-360 40-600l440-240 440 240v320h-80ZM480-120 200-272v-200l280 152 280-152v200L480-120Z"/></svg>
)

const FilledSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M818.46-320.31v-254.46L480-407.079 89.541-600 480-792.921 870.458-600v279.69H818.46ZM480-190.157l-243.999-121.23v-140.537L480-330.694l243.999-121.23v140.537L480-190.157Z"/></svg>
)

export const SchoolIcon = createIconComponent({
  OutlinedLarge,
  OutlinedSmall,
  FilledLarge,
  FilledSmall,
})
